export enum RecurrenceType {
  Daily = 0,
  Weekly = 1,
  MonthlyByDayOfMonth = 2,
  MonthlyByDayOfWeek = 3,
  Yearly = 4,
}
